import { useState, useEffect, useCallback } from 'react';
import styled from 'styled-components';
import { useParams } from 'react-router-dom';
import { withAppHOC } from '../../../hoc';
import PageHeading from '../../../components/PageHeader/PageHeader';
import API from '../../../api';
import { API_RESPONSE_TYPES } from '../../../constants';
import LoadingSpinner from '../../../components/LoadingSpinner/LoadingSpinner';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faCircleCheck,
  faCircleXmark,
  faExclamationCircle,
} from '@fortawesome/free-solid-svg-icons';

const StyledStatusContainer = styled.section`
  text-align: center;
  padding: 50px 0px;
`;

const StyledStatusIcon = styled.section`
  font-size: 50px;
  svg {
    &.blue {
      color: #0095ff;
    }
    &.green {
      color: forestgreen;
    }
    &.red {
      color: red;
    }
  }
`;

const StyledStatusHeading = styled.h1`
  font-size: 20px;
  font-weight: normal;
  margin: 10px 0px;
  padding: 0px;
  &.blue {
    color: #0095ff;
  }
  &.green {
    color: forestgreen;
  }
  &.red {
    color: red;
  }
`;

const StyledStatusMessage = styled.p`
  font-size: 14px;
  font-weight: normal;
  color: #000000;
  margin: 0px;
  padding: 0px;
`;

const PANStatus = (props) => {
  const [isLoading, setIsLoading] = useState(false);
  const [responseStatus, setResponseStatus] = useState('');
  const [responseMessage, setResponseMessage] = useState('');
  const [data, setData] = useState(null);
  const { id } = useParams();
  const encryptedData = window.location.search.replace('?encrypted_data=', '');
  const readData = useCallback(() => {
    setIsLoading(true);
    setResponseStatus('');
    setResponseMessage('');
    API.get(
      `/transactions/pan-decrypt-data/${id}?encrypted_data=${encodeURIComponent(
        encryptedData
      )}`
    )
      .then((response) => {
        const { status, message, data } = response.data;
        if (status === API_RESPONSE_TYPES.SUCCESS) {
          setData(data);
          setTimeout(() => {
            window.location.pathname = '/transactions/pan-transactions';
          }, 3000);
        } else {
          setResponseStatus(status);
          setResponseMessage(message);
        }
      })
      .catch((error) => {
        setResponseStatus(API_RESPONSE_TYPES.FAILURE);
        setResponseMessage(error.message);
      })
      .finally(() => {
        setIsLoading(false);
      });
  }, [id]);

  useEffect(() => {
    readData();
  }, [readData]);

  return (
    <>
      <PageHeading {...props} />
      <StyledStatusContainer>
        {isLoading && <LoadingSpinner isLoading={isLoading} />}
        {!isLoading && (
          <>
            <StyledStatusIcon>
              <FontAwesomeIcon
                icon={
                  data?.transactionStatus === 'Pending'
                    ? faExclamationCircle
                    : data?.transactionStatus === 'Success'
                    ? faCircleCheck
                    : faCircleXmark
                }
                className={
                  data?.transactionStatus === 'Pending'
                    ? 'blue'
                    : data?.transactionStatus === 'Success'
                    ? 'green'
                    : 'red'
                }
              />
            </StyledStatusIcon>
            <StyledStatusHeading
              className={
                data?.transactionStatus === 'Pending'
                  ? 'blue'
                  : data?.transactionStatus === 'Success'
                  ? 'green'
                  : 'red'
              }
            >
              {data?.transactionStatus}
            </StyledStatusHeading>
            <StyledStatusMessage>{data?.panStatus}</StyledStatusMessage>
          </>
        )}
      </StyledStatusContainer>
    </>
  );
};

export default withAppHOC(PANStatus);
